export default "__VITE_ASSET__BsdifUL0__"